import {Component, Input} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ReflexiveRestModel} from '../../reflexive-model/reflexive-rest-model';
import {ReflexiveField} from '../../reflexive-model/reflexive-field';
import {FieldType} from '../../reflexive-model/field-type.enum';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-variation-array-field',
  templateUrl: './gelios-variation-array-field.component.html',
  styleUrls: ['./gelios-variation-array-field.component.scss']
})
export class GeliosVariationArrayFieldComponent {
  protected readonly fieldType = FieldType;
  @Input() fieldName: string;
  @Input() formGroup: FormGroup;
  @Input() model: ReflexiveRestModel;
  @Input() reflexiveField: ReflexiveField;

  addNewChild() {
    const newFormControl = this.formBuilder.control(
      this.model.fields[this.fieldName].variationArrayConfig.childFieldConfig.value,
      this.model.fields[this.fieldName].variationArrayConfig.childFieldConfig.validators
    );
    const formArray = this.formGroup.controls[this.fieldName] as FormArray;
    formArray.push(newFormControl);
    formArray.markAsTouched();
    formArray.updateValueAndValidity();
  }

  constructor(
    protected translate: TranslateService,
    protected formBuilder: FormBuilder,
  ) {
  }

  removeChild(index: number) {
    const formArray = this.formGroup.controls[this.fieldName] as FormArray;
    const fieldValue = this.model.fields[this.fieldName].value as Array<string>;

    formArray.removeAt(index);
    fieldValue.splice(index, 1);

    formArray.markAsTouched();
    formArray.updateValueAndValidity();
  }

  getPlaceholder(index: number) {
    const placeholder = this.reflexiveField.variationArrayConfig.childFieldConfig.placeholder;
    return this.translate.instant(placeholder.toString()) + ' ' + (index + 1);
  }

  getFormControls(formGroup: FormGroup): Array<FormControl> {
    return (formGroup.get(this.fieldName) as FormArray).controls as Array<FormControl>;
  }
}
